import { IconButton } from '@trg/tlw-ui-component';
import { useMenuStore } from '../../stores';
import { useHeaderData } from '../../hooks';
import { selectTotalCategories } from '../../api';

export function Burger() {
  const setMenuOpen = useMenuStore.use.setMenuOpen();
  const setSelectedCategory = useMenuStore.use.setSelectedCategory();

  const data = useHeaderData();
  const totalCategory = selectTotalCategories(data);

  const handleClick = () => {
    setSelectedCategory(totalCategory[0]);
    setMenuOpen(true);
  };

  return (
    <IconButton
      className="tlw-p-0 tlw-text-2xl lg:tlw-text-xl"
      icon="Burger"
      square
      onClick={handleClick}
    />
  );
}
